(function() {
	var selects = document.querySelectorAll('.GzlyCustomSelect');

	var html = document.getElementsByTagName('html')[0];
	html.addEventListener('click', function () {
		for (var i = 0; i < selects.length; i++) {
			selects[i].classList.remove('GzlyCustomSelect__open');
		}
	});

	var onLabelClick = function (event) {
		event.stopPropagation();

		for (var i = 0; i < selects.length; i++) {
			if (this !== this) {
				this.classList.remove('GzlyCustomSelect__open');
			}
		}

		this.classList.toggle('GzlyCustomSelect__open');
	};

	var getSelectedOptions = function (select) {
		var options = select.querySelectorAll('.GzlyCustomSelect--option');

		var data = [];
		for (var i = 0; i < options.length; i++) {
			if (options[i].getAttribute('data-selected') === 'true') {
				data.push(options[i].getAttribute('data-value'));
			}
		}

		return data;
	};

	var onOptionClick = function (event) {
		event.stopPropagation();

		if (event.target.getAttribute('data-selected') === 'true') {
			event.target.setAttribute('data-selected', false);
		} else {
			event.target.setAttribute('data-selected', true);
		}

		var data = getSelectedOptions(this);

		UTIL.fire(this, 'GzlyCustomSelect:change', data);
	};

	for (var i = 0; i < selects.length; i++) {
		selects[i].querySelector('.GzlyCustomSelect--label').addEventListener('click', onLabelClick.bind(selects[i]));

		var options = selects[i].querySelectorAll('.GzlyCustomSelect--option');
		for (var j = 0; j < options.length; j++) {
			options[j].addEventListener('click', onOptionClick.bind(selects[i]));
		}
	}

})();